// import PropTypes from 'prop-types';
import React, { Component } from 'react';
import NotificationBox from '../NotificationBox';

export default class NotificationPopUp extends Component {
  render() {
    return <NotificationBox {...this.props} modal={true} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/modals/NotificationModal.js